module.exports = __webpack_public_path__ + "img/shop7-3.b7ba6244.png";